export const getMemberDetailsSelectedUserId = (state) => state.memberDetails.selectedUserId;
